import { computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import { isCustomerVisibleWorkOrder, workOrdersApi } from '@ck/api-client'

// A API já escopa /work-orders para as OS publicadas do cliente autenticado; usamos a
// primeira como OS ativa (um cliente com múltiplos veículos em restauração simultânea não é
// o caso comum hoje). Compartilhado entre Acompanhamento e Relatório final.
export function useActiveWorkOrder() {
  const workOrderQuery = useQuery({ queryKey: ['my-work-orders'], queryFn: () => workOrdersApi.list() })
  const activeWorkOrder = computed(() => workOrderQuery.data.value?.items.find(isCustomerVisibleWorkOrder))

  const detailQuery = useQuery(computed(() => ({
    queryKey: ['work-order-detail', activeWorkOrder.value?.id],
    queryFn: async () => {
      const detail = await workOrdersApi.get(activeWorkOrder.value!.id)
      return isCustomerVisibleWorkOrder(detail) ? detail : null
    },
    enabled: !!activeWorkOrder.value
  })))

  return { workOrderQuery, activeWorkOrder, detailQuery }
}
